exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-width[data-v-173e3b34]{width:200px}", ""]);

// exports
